<template>
<div class="signup container">
    <form class="card-panel" @submit.prevent="signup">
        <h2 class="center deep-purple-text">Registrieren</h2>
        <div class="field">
                <label for="email">Email</label>
                <input type="email" name="email" v-model="email">
        </div>
        <div class="field">
            <label for="password">Password</label>
            <input type="password" name="password" v-model="password">
        </div>
        <div class="field">
            <label for="alias">Alias</label>
            <input type="text" name="alias" v-model="alias">
        </div>
        <p class="red-text center" v-if="feedback">{{feedback}}</p>
        <div class="field center">
            <button class="btn deep-purple">Registrieren</button>
        </div>
    </form>
</div>
</template>

<script>
    import slugify from 'slugify'
    import db from '@/firebase/init'
    import firebase from 'firebase'
    import functions from 'firebase/functions'

    export default {
        name: "SignUp",
        data() {
            return {
                email: null,
                password: null,
                alias: null,
                feedback: null,
                slug: null
            }
        },
        "methods": {
            "signup"() {
                if (this.alias && this.email && this.password) {
                    this.slug = slugify(this.alias, {
                        replacement: '-',
                        remove: /[$*_+`.()'"!\-:@]/g,
                        lower: true
                    })
                    let checkAlias = firebase.functions().httpsCallable('checkAlias')
                    checkAlias({slug: this.slug}).then(result => {
                        if (!result.data.unique) {
                            this.feedback = 'Dieser Alias existiert schon'
                    //})
                    // let ref = db.collection('users').doc(this.slug)
                    //  ref.get().then(doc => {
                        } else {
                            firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                                .then(user => {
                                    let ref = db.collection('users').doc(this.slug)
                                    ref.set({
                                        alias: this.alias,
                                        geolocation: null,
                                        user_id: user.user.uid
                                    })
                                }).then(() => {
                                this.$router.push({name: 'GMap'})
                            })
                                .catch(err => {
                                    this.feedback = err.message
                                })
                            this.feedback = 'Dieser Alias ist frei zum benützen'
                        }
                    })
                } else {
                    this.feedback = "Sie müssen alle Felder eintragen"
                }
            }
        }
    }

</script>

<style scoped>
    .signup{
        max-width: 400px;
        margin-top: 60px;
    }
    .signup h2{
        font-size: 2.4em;
    }
    .signup .field{
        margin-bottom: 16px;
    }

</style>
